import { createFileRoute, Navigate } from "@tanstack/react-router";
import React from "react";

/**
 * The properties for {@link DnsRedirect}
 */
export type DnsRedirectProps = {};

/**
 * Redirect page for DNS
 */
export default function DnsRedirect(props: DnsRedirectProps) {
    return <Navigate to={"/a/dns/global"} search={{ search: "", page: 1 }} />;
}

export const Route = createFileRoute("/_admin/a/dns/")({
    component: DnsRedirect,
});
